import React from 'react';
import Header from '../Header';
import { Box, Flex, FlexProps } from 'rebass';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

export const MainColumn = (props: FlexProps): JSX.Element => (
  <Flex
    as="main"
    bg="background"
    color="text"
    flexDirection="column"
    {...(props as any)}
  />
);

type ThirdPaneWrapperProps = {
  paneVisible?: boolean;
  paneWidth?: number;
};

const ThirdPaneWrapper = styled(Box)<ThirdPaneWrapperProps>`
  // background: green;
  position: relative;
  overflow: hidden;

  main {
    height: calc(100vh - 50px);
    overflow: hidden;
    background: linear-gradient(0deg, #fff, #fff, #f1f1f1);
  }

  .third-pane {
    transition: transform 0.3s ease;
    width: ${(props) => (props.paneWidth ? `${props.paneWidth}` : 400)}px;
    max-width: 100vw;
  }

  .third-pane-toggle {
    transition-delay: 0.3s;
    opacity: ${(props) => (props.paneVisible ? '1' : '0')};
    transform: ${(props) =>
      props.paneVisible ? 'translateX(0)' : 'translateX(100%)'};
  }
`;

type LayoutProps = {
  children?: React.ReactNode;
  paneVisible?: boolean;
  paneWidth?: number;
};

/**
 * @component for page layout
 */
const ThirdPaneLayout = (props: LayoutProps): JSX.Element => {
  return (
    <>
      <Header />
      <ThirdPaneWrapper
        paneWidth={props.paneWidth}
        paneVisible={props.paneVisible}
      >
        {props.children}
      </ThirdPaneWrapper>
    </>
  );
};

ThirdPaneLayout.propTypes = {
  children: PropTypes.node,
};

export default ThirdPaneLayout;
